import { ServiceType, SERVICE_TYPES, PORTS, API_HOSTS } from '@/components/constants'

export const API = {
    ENDPOINTS: {
        SIGNUP: (service: ServiceType = SERVICE_TYPES.FOODSLABO) => {
            try {
                const { protocol, hostname, port } = window.location

                const pfDomain = window.ENV?.PF_DOMAIN
                if (pfDomain) {
                    return `${protocol}//${pfDomain}/api/v1/job_seekers/${service}`
                }

                let apiHostname = hostname

                if (hostname.includes('stg.foods-labo') || hostname.includes('stg.hotels-labo')) {
                    apiHostname = API_HOSTS.STG
                }
                else if (hostname.includes('foods-labo') || hostname.includes('hotels-labo')) {
                    apiHostname = API_HOSTS.PROD
                }

                const apiOrigin = port === PORTS.APP
                    ? `${protocol}//${apiHostname}:${PORTS.API}`
                    : `${protocol}//${apiHostname}${port ? `:${port}` : ''}`
                return `${apiOrigin}/api/v1/job_seekers/${service}`
            } catch {
                return `/api/v1/job_seekers/${service}`
            }
        },
        // DEV-3303: 宛先の決め方は登録APIと必ず同じにするため、SIGNUP の URL に続けて組み立てる
        PRE_ENTRY_NOTIFICATION: (service: ServiceType = SERVICE_TYPES.FOODSLABO) =>
            `${API.ENDPOINTS.SIGNUP(service)}/pre_entry_notifications`,
    },
    HEADERS: {
        CONTENT_TYPE: 'application/json',
    },
} as const
